module.exports = __webpack_public_path__ + "static/media/vb.3c5942e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/vb.png
// module id = 1799
// module chunks = 146